import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import BUILDIRQSeeVaLoanOptionsView from "../views/IrqSeeVaLoanOptionsView";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { bool, object } from "yup";
import StatusCheck from "../components/StatusCheck";

class BuildIrqSeeVaLoanOptionsPage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="buildIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            lookAtVaLoans: bool().required(),
          })}
        >
          <BUILDIRQSeeVaLoanOptionsView
            content={contentMap.BuildIrqSeeVaLoanOptionsPage}
            navigationsAway={customNavigationMap.BuildIrqSeeVaLoanOptionsPage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(BuildIrqSeeVaLoanOptionsPage);
